class generalHelper{
	constructor() {
		this.bindGeneralModal();
	}
	bindGeneralModal() {
		$('.modal--general').modal('show');
	}
}
window.app.add('general', new generalHelper());